import React from 'react';
import { useState,  useRef,useEffect } from 'react';
import './classes/CourseOverview.css';
import './classes/marquee.css';
import './classes/ConferenceRegistration.css';
import BeTheFirstToKnowPopup from './BeTheFirstToKnowPopup';
import CurrencyConverter from "./shortcodes/CurrencyConverter";
import CourseCalendar from "./shortcodes/CourseCalendar";
import SidebarQuickForm from './SidebarQuickForm';
import Mentor from './Mentor';
import { createRoot } from "react-dom/client";

import { configData } from "../config";

// Audio players in page bodies, by the name of the Drupal script that sets each one up
// (/sites/all/themes/smww/js/audio/<name>): the picture and recording it plays.
const AUDIO_PLAYERS = {
    'mel-kipper.js': { image: '/audio/mel_kiper.png', audio: '/audio/MelKiperJrAudio.mp3' },
};

const Body = ({ page }) => {
  const app_url = configData.APP_URL;
 const bodyRef = useRef(null);
 const [showBeTheFirstToKnow, setShowBeTheFirstToKnow] = useState(false);
useEffect(() => {
    const ul = document.getElementById("marquee-horizontal");

    if (ul && !ul.dataset.initialized) {
        ul.innerHTML += ul.innerHTML;
        ul.dataset.initialized = "true";
    }
}, [page?.body]);
useEffect(() => {
    if (!bodyRef.current) return;

    bodyRef.current
        .querySelectorAll('[data-type="currency-converter"]')
        .forEach((element) => {
            createRoot(element).render(
                <CurrencyConverter
                    price={parseFloat(element.dataset.price)}
                />
            );
        });

         bodyRef.current
        .querySelectorAll('[data-type="mobile-quick-form"]')
        .forEach((element) => {
            createRoot(element).render(
                <div className="mobile-only">
                    <SidebarQuickForm page={page} />
                </div>
            );
        });
        bodyRef.current
        .querySelectorAll('[data-type="course-calendar"]')
        .forEach((element) => {
            createRoot(element).render(<CourseCalendar />);
        });
        bodyRef.current
        .querySelectorAll('[data-type="mobile-mentor-block"]')
        .forEach((element) => {
            createRoot(element).render(
                <div className="mobile-only">
                    <Mentor page={page} />
                </div>
            );
        });

}, [page?.body]);
// Home page video: on the Drupal site a script swaps the cover image for the
// video when it is clicked. Scripts in the body are not run here, so do the same.
useEffect(() => {
    if (!bodyRef.current) return;

    const overlays = bodyRef.current.querySelectorAll('.video_overlay');
    const playVideo = (event) => {
        const overlay = event.currentTarget;
        const cover = overlay.querySelector('.cover_image');
        if (!cover) return;

        const video = document.createElement('video');
        // The video sits next to its cover image in the Drupal files folder
        video.src = new URL('home_page_video1.mp4', cover.src).href;
        video.controls = true;
        video.autoplay = true;
        overlay.parentNode.replaceChild(video, overlay);
    };

    overlays.forEach((overlay) => overlay.addEventListener('click', playVideo));
    return () => overlays.forEach((overlay) => overlay.removeEventListener('click', playVideo));
}, [page?.body]);
// YouTube players (<div class="video" data-id="...">): the Drupal site's script puts the
// video's cover picture and a play button in them, and swaps in the video when clicked.
useEffect(() => {
    if (!bodyRef.current) return;

    bodyRef.current.querySelectorAll('.player .video[data-id]').forEach((video) => {
        if (video.querySelector('div, iframe')) return;

        const cover = document.createElement('div');
        const thumb = document.createElement('img');
        thumb.src = 'https://i.ytimg.com/vi/' + video.dataset.id + '/hqdefault.jpg';
        thumb.alt = '';
        cover.append(thumb, document.createElement('span'));
        cover.onclick = () => {
            const iframe = document.createElement('iframe');
            iframe.src = 'https://www.youtube.com/embed/' + video.dataset.id + '?autoplay=1';
            iframe.allowFullscreen = true;
            iframe.allow = 'autoplay';
            iframe.frameBorder = '0';
            video.replaceChild(iframe, cover);
        };
        video.appendChild(cover);
    });
}, [page?.body]);
// Audio players (<div class="audio-player-wrapper">): on the Drupal site each one is set up by
// its own script in the body, which names the picture and the recording. Scripts in the body
// are not run here, so the same is done for the scripts listed in AUDIO_PLAYERS.
useEffect(() => {
    if (!bodyRef.current) return;

    const body = bodyRef.current;
    const wrapper = body.querySelector('.audio-player-wrapper');
    const script = [...body.querySelectorAll('script[src*="/js/audio/"]')]
        .map((el) => el.getAttribute('src').split('/').pop())
        .find((name) => AUDIO_PLAYERS[name]);
    if (!wrapper || !script || wrapper.querySelector('audio')) return;

    const song = AUDIO_PLAYERS[script];
    const audio = document.createElement('audio');
    audio.src = configData.DRUPAL_DOMAIN_URL + song.audio;
    audio.preload = 'none';
    const image = document.createElement('img');
    image.src = configData.DRUPAL_DOMAIN_URL + song.image;
    image.alt = '';
    wrapper.querySelector('.audio-player-image')?.appendChild(image);
    wrapper.appendChild(audio);

    const button = wrapper.querySelector('.audio-player-button');
    const progress = wrapper.querySelector('.audio-player-progress');
    const bar = wrapper.querySelector('.audio-player-progress-bar');
    const showState = () => {
        button?.classList.toggle('icon-play', audio.paused);
        button?.classList.toggle('icon-pause', !audio.paused);
    };
    const showProgress = () => {
        if (bar && audio.duration) bar.style.width = (audio.currentTime / audio.duration) * 100 + '%';
    };
    const togglePlay = () => (audio.paused ? audio.play() : audio.pause());
    const seek = (event) => {
        if (audio.duration) audio.currentTime = audio.duration * (event.offsetX / progress.offsetWidth);
    };

    audio.addEventListener('play', showState);
    audio.addEventListener('pause', showState);
    audio.addEventListener('timeupdate', showProgress);
    button?.addEventListener('click', togglePlay);
    progress?.addEventListener('click', seek);
    return () => {
        audio.pause();
        button?.removeEventListener('click', togglePlay);
        progress?.removeEventListener('click', seek);
        image.remove();
        audio.remove();
    };
}, [page?.body]);
// Conference pages: the "Be The First To Know" buttons in the body open the sign-up popup
useEffect(() => {
    if (!bodyRef.current) return;

    const buttons = bodyRef.current.querySelectorAll('[data-type="be-the-first-to-know"]');
    const openPopup = (event) => {
        event.preventDefault();
        setShowBeTheFirstToKnow(true);
    };

    buttons.forEach((button) => button.addEventListener('click', openPopup));
    return () => buttons.forEach((button) => button.removeEventListener('click', openPopup));
}, [page?.body]);
// Body images that fail to load: files added on the live site after the Drupal copy was
// taken are missing there, so try the live site once, then hide the image so a missing
// file does not leave an empty box
useEffect(() => {
    if (!bodyRef.current) return;

    const body = bodyRef.current;
    const copyFiles = configData.DRUPAL_DOMAIN_URL + '/sites/';
    const liveFiles = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/';
    const retryOrHide = (img) => {
        if (img.src.startsWith(copyFiles)) {
            img.src = liveFiles + img.src.slice(copyFiles.length);
        } else {
            img.style.display = 'none';
        }
    };
    const onError = (event) => {
        if (event.target.tagName === 'IMG') retryOrHide(event.target);
    };

    // error events do not bubble, so listen in the capture phase
    body.addEventListener('error', onError, true);
    body.querySelectorAll('img').forEach((img) => {
        if (img.complete && img.naturalWidth === 0) retryOrHide(img);
    });
    return () => body.removeEventListener('error', onError, true);
}, [page?.body]);
  // Drupal files (/sites/...) are not on this server, so load them from the Drupal site
  // Application links typed with the live domain would leave this site, so keep them on the current one
  const bodyHtml = (page?.body || "")
    .replace(/(\ssrc=["'])\/sites\//g, `$1${configData.DRUPAL_DOMAIN_URL}/sites/`)
    .replace(/(\shref=["'])https?:\/\/(?:www\.|team\.)?sportsmanagementworldwide\.com\/application(?=["'?#])/gi, '$1/application');
  return (
    <div className="courses-overview-container">
      <div  ref={bodyRef}
                dangerouslySetInnerHTML={{
                    __html: bodyHtml
                }}
            />
      <BeTheFirstToKnowPopup open={showBeTheFirstToKnow} onClose={() => setShowBeTheFirstToKnow(false)} />
    </div>
  );
};
export default Body;